export enum ReportTypesNavLabels {
    All,
    User,
    Shared,
    System
}
